import { call, takeLatest, put } from "redux-saga/effects";
import { REQUEST_API_AUTH, receiveApiData } from "../actions/actions";
import { auth } from "../../services/api/auth";
import { checkIsAdminApi } from "../../services/api/admin";
import { CHECK_IS_ADMIN, isAuthAdmin } from "../actions/auth.action";

// worker Saga: will be fired on USER_FETCH_REQUESTED actions
function* getAuth({ data: { body, callback } }) {
  try {
    // do api call
    const res = yield call(auth, body);
    const { data, status } = res;
    if (res.data) {
      yield put(receiveApiData({ guest: data.message }));
    }
    callback(status || res.response.status);
  } catch (e) {}
}

function* checkIfAdminAsync(callback = () => {}) {
  try {
    const res = yield call(checkIsAdminApi);
    const { data } = res;
    let isAdmin = data.isAdmin;
    if (res.data) {
      yield put(isAuthAdmin(isAdmin));
    } else {
      yield put(isAuthAdmin(false));
      callback();
    }
  } catch (e) {
    console.error(e);
  }
}
/*
  Alternatively you may use takeLatest.
  Does not allow concurrent fetches of user. If "USER_FETCH_REQUESTED" gets
  dispatched while a fetch is already pending, that pending fetch is cancelled
  and only the latest one will be run.
*/
export function* authSaga() {
  yield takeLatest(REQUEST_API_AUTH, getAuth);
}

export function* checkIfAdminSaga() {
  yield takeLatest(CHECK_IS_ADMIN, checkIfAdminAsync);
}
